<template>
  <v-app>
    <v-container>
      <v-row no-gutters>
        <Header></Header>
      </v-row>
      <v-row no-gutters class="flex-nowrap">
        <Navigation v-show="$vuetify.breakpoint.mdAndUp" />
        <v-col>
          <AppBar />
          <router-view style="padding: 1rem" />
        </v-col>
        <!-- <Contact/> -->
      </v-row>
      <v-row no-gutters>
        <Footer />
      </v-row>
    </v-container>
  </v-app>
</template>

<script lang="js">
import Header from "@/components/Header.vue";
import Navigation from '@/components/Navigation.vue';
import AppBar from '@/components/AppBar.vue';
import Footer from "@/components/Footer.vue";
import { useUserServiceInject } from '@/context';

export default {
  setup(props, { root }) {
      const { getUserToken, destroyToken, accessToken, loggedIn } = useUserServiceInject();
      getUserToken();
      root.$axios.interceptors.response.use(undefined, function(err) {
        if (!err) return;
        if (!err.response) return;
        if (err.response.status == "401" && (loggedIn.value || accessToken.value.length)) {
          destroyToken();
          location.reload();
      }
    });
  },
  components: {
    Header, Navigation, AppBar, Footer
  },
}
</script>

<style>
@import "./assets/css/style.css";

.row {
  max-width: none;
}

.tum-blue {
  color: #0065bd;
}

.container {
  padding: 0;
}

.v-application a {
  color: inherit !important;
}

a {
  border: none;
  color: inherit;
}

input {
  border: none;
}

body {
  cursor: default;
}
button,
input[type="submit"] {
  background-color: transparent !important;
}

.link:hover {
  text-decoration: underline !important;
  cursor: pointer;
}
</style>
